// extracted by mini-css-extract-plugin
module.exports = {"mailMagazineLink":"mailMagazineLink","mailMagazineLink_ArrowRight":"mailMagazineLink_ArrowRight","textLink":"textLink"};